/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import listModule, { StoreSecretTopicListState } from './list';
import detailModule, { StoreSecretTopicDetailState } from './detail';

export interface StoreSecretTopicState {
  // modules
  list: StoreSecretTopicListState;
  detail: StoreSecretTopicDetailState;
}

export default {
  namespaced: true,
  modules: {
    list: listModule,
    detail: detailModule,
  },
  state: {},
  getters: {},
  actions: {},
  mutations: {},
};
